'use strict';
import Firebase from 'firebase';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/publishReplay';

// source: https://gist.github.com/gsoltis/ee20138502a4764650f2.git
Firebase.prototype.__proto__.observe = function(eventType) {
  return Observable.create(observer => {
    const listener = this.on(eventType, makeCallback(eventType, observer), error => {
      observer.error(error);
    });
    return () => {
      this.off(eventType, listener);
    }
  }).publishReplay(1).refCount();
};

function makeCallback(eventType, observer) {
  if (eventType === 'value') {
    return function(snap) {
      observer.next(snap);
    };
  } else {
    return function(snap, prevName) {
      // Wrap into an object, since we can only pass one argument through.
      observer.next({snapshot: snap, prevName: prevName});
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/_libs/rx-firebase/index.js